import { useEffect, useState } from "react";

type Selection = { onlyMe: boolean; ids: string[] | null };
const initial: Selection = { onlyMe: false, ids: null };
function read(key: string): Selection {
  try {
    const value = JSON.parse(localStorage.getItem(key) || "null");
    if (value && typeof value.onlyMe === "boolean" && (value.ids === null || (Array.isArray(value.ids) && value.ids.every((id: unknown) => typeof id === "string")))) return value;
  } catch { /* The calendar remains usable when storage is unavailable. */ }
  return initial;
}

export default function useCalendarSelection(account: string) {
  const key = `calendar-selection:${account}`;
  const [saved, setSaved] = useState(() => ({ key, selection: read(key) }));
  const selection = saved.key === key ? saved.selection : read(key);
  useEffect(() => { setSaved({ key, selection: read(key) }); }, [key]);
  const choose = (next: Selection) => {
    setSaved({ key, selection: next });
    try { localStorage.setItem(key, JSON.stringify(next)); } catch { /* Keep the in-memory choice. */ }
  };
  return { selection, choose };
}
